import { render, staticRenderFns } from "./TableDeleteDialog.vue?vue&type=template&id=67a365c2&"
import script from "./TableDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./TableDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports